<template>
  <div>
    <el-dialog
        :title="title"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        @closed="closeForm"
    >
      <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="105px"
          :rules="rules"
          class="demo-ruleForm"
      >
        <el-form-item v-if="dialogParams.selectIndex !== 3" label="标题" prop="title">
          <el-input v-model="ruleForm.title" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="dialogParams.selectIndex === 3" label="职工姓名" prop="ename">
          <el-input v-model="ruleForm.ename" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="dialogParams.selectIndex === 2" label="营业额" prop="amount">
          <el-input v-model="ruleForm.amount" clearable>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="dialogParams.selectIndex === 2" label="经营目标" prop="target">
          <el-input v-model="ruleForm.target" clearable></el-input>
        </el-form-item>
        <el-form-item label="所属年度" prop="annual">
          <el-date-picker
              v-model="ruleForm.annual"
              type="year"
              placeholder="选择年度"
              format="yyyy"
              value-format="yyyy"
              style="text-align: left; width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-if="dialogParams.selectIndex === 2" label="经营计划" prop="operatePlan">
          <!-- <editor :quill-data="ruleForm.content" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
          <editor
              v-model="ruleForm.operatePlan"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
          ></editor>
        </el-form-item>
        <el-form-item v-if="dialogParams.selectIndex !== 2" label="内容" prop="content">
          <!-- <editor :quill-data="ruleForm.content" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
          <editor
              v-model="ruleForm.content"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
          ></editor>
        </el-form-item>
<!--        :disabled="disabled"-->
        <el-form-item label="附件上传">
          <el-upload
              class="upload-demo"
              :action="this.uploadURL"
              name="file"
              :file-list="fileList"
              :show-file-list="true"
              :on-remove="onRemove"
              :on-success="handlePictureCardPreview"
              :on-preview="onPreview"
              accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
<!--        <el-form-item label="附件上传" prop="fileList">-->
<!--          <el-upload class="upload-demo" :action="this.uploadURL" style="text-align: left;" :before-upload="beforeAvatarUpload"-->
<!--                     :on-remove="(file, fileList)=>handleRemove(file, fileList,'fileList')" :file-list="fileList" :on-success="(response, file, fileList) => handleAvatarSuccess(response, file, fileList,'fileList')"-->
<!--                     list-type="picture">-->
<!--            <el-button size="small" type="primary" >上传附件材料</el-button>-->
<!--          </el-upload>-->
<!--        </el-form-item>-->

        <el-form-item label="" prop="status" style="text-align: left">
          <el-col :span="24" style="text-align: right">
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="closeForm('ruleForm')">取消</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import editor from "@/components/tinymce-editor/tinymce-editor.vue";
import {DisabledDateFn, FunDownload} from "@/utils/tool";

export default {
  name: "dialogYearReport",
  components: {editor},
  props:{
    title:{
      type:String,
      default:'详情'
    },
    dialogFormVisible:{
      type:Boolean
    },
    dialogParams:{
      type:Object,
      default: (()=>{
        return {
          type:'add',
          id:'',
          selectIndex:1
        }
      })
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDateFn
      },
      //禁用日期选择
      disabledDateFn(time) {
        return DisabledDateFn(time);
      },
      urlLise : [
        'information-annual-report',
        'information-operate-manage',
        'information-employee-equity',
        'information-social-liability',
      ],
      ruleForm: {
        title: "", // 标题
        annual: "", // 所属年度
        amount:'', // 营业额
        target:'', // 经营目标
        content: "", // 维护内容
        attachments: "", // 附件
        fileList:[], // 附件
        ename:'', // 职工姓名
      },
      rules: {
        title: [{required: true, message: '请输入标题', trigger: 'blur'}],
        annual: [{required: true, message: '请选择年度', trigger: 'change'}],
        content: [{required: true, message: '请输入内容', trigger: 'blur'}],
        amount: [{required: true, message: '请输入营业额', trigger: 'blur'}],
        target: [{required: true, message: '请输入经营目标', trigger: 'blur'}],
        operatePlan: [{required: true, message: '请输入经营计划', trigger: 'blur'}],
        ename: [{required: true, message: '请输入职工姓名', trigger: 'blur'}],
      },
      fileList:[],
      file: [],
    }
  },
  mounted() {
    if(this.dialogParams.type === 'edit'){
      this.getDetail(this.dialogParams.id)
    }
  },
  methods: {
    getDetail(id){
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/voucher/${this.urlLise[this.dialogParams.selectIndex - 1]}/get?id=${id}`)
          .then(res => {
            if (res.code === 0) {
              res.data.annual = String(res.data.annual)
              this.fileList = JSON.parse(res.data.fileList)
              this.ruleForm = res.data
            } else {
              this.$message.error(res.status);
            }
          });
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          obj.amount = Number(obj.amount)
          obj.annual = Number(obj.annual)
          obj.fileList = JSON.stringify(this.fileList)
          if(Array.isArray(obj.fileList) && obj.fileList.length === 0){
            obj.fileList = JSON.stringify(obj.fileList)
          }
          // obj.fileList = JSON.stringify(obj.fileList)
          console.log(obj, 'obj');
          if (this.dialogParams.type === 'add') {
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/${this.urlLise[this.dialogParams.selectIndex - 1]}/create`, obj)
                .then(res => {
                  if (res.code === 0) {
                    this.$emit('handelDialogClose')
                    this.$emit('search')
                  } else {
                    this.$message.error(res.status);
                  }
                });
          } else {
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/${this.urlLise[this.dialogParams.selectIndex - 1]}/update`, obj)
                .then(res => {
                  if (res.code === 0) {
                    this.$message.success('编辑成功');
                    this.$emit('handelDialogClose')
                  } else {
                    this.$message.error(res.status);
                  }
                });
          }
        }
      });
    },
    onRemove(file, fileList) {
      this.fileList = this.getList(fileList);
    },
    handlePictureCardPreview(response, file, fileList) {
      this.fileList = this.getList(fileList);
    },
    onPreview(file) {
      console.log('file',file)
      FunDownload(this.imgUrl + file.url, file.name);
      // FunDownload(file.url, file.name);
    },
    getList(fileList) {
      return fileList.map((el) => {
        return {
          name: el.name,
          url: el?.url || el?.response?.data.store_result,
          uid: el.uid,
        };
      });
    },
    // 取消
    closeForm(){
      this.$emit('handelDialogClose')
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return isLt2M;
    },
    handleRemove(file, fileList, type) {
      this.fileList = fileList
      if(fileList.length === 0) {
        this.ruleForm.fileList = ""
      }else{
        this.ruleForm.fileList = JSON.stringify(fileList)
      }
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this.fileList = fileList

        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name
          });
        });
        this.ruleForm[type] = JSON.stringify(arr);

        // if (type === 'logoSrc' || type === 'realImageSrc') {
        //   this.ruleForm[type] = arr[0].url;
        // }
      } else {
        this.ruleForm[type] = '';
        this[type] = [];
      }
    },
  },
}
</script>



<style scoped lang="scss">

</style>
